import { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { AppDispatch } from 'services/store';
import { getTrack } from 'services/store/ai';
import { checkLoadingSelector } from 'services/store/base/selectors';
import { selectSong } from 'services/store/newSongs/selectors';
import { getSong, songsActionNames } from 'services/store/songs/actions';
import type { StoreRootState } from 'services/store/types';

export const useAiSong = (id: string) => {
  const dispatch = useDispatch<AppDispatch>();

  const song = useSelector(selectSong(id));
  const base = useSelector((store: StoreRootState) => store.base);

  useEffect(() => {
    dispatch(getTrack({ songId: id }));
  }, [dispatch, id]);

  return {
    song,
    isLoading: checkLoadingSelector(base, [songsActionNames.GET_SONG]),
  };
};

export const useRegularSong = (id: string) => {
  const dispatch = useDispatch();

  const song = useSelector(selectSong(id));
  const base = useSelector((store: StoreRootState) => store.base);

  useEffect(() => {
    dispatch(getSong({ songId: id }));
  }, [dispatch, id]);

  return {
    song,
    isLoading: checkLoadingSelector(base, [songsActionNames.GET_SONG]),
  };
};
